module.exports = new __parcel__URL__("cyberconnect.027ff4b1.svg").toString();